/**
 * @generated SignedSource<<ffbf6eeba86a72add4b8f2f8a850d118>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutShippingForm_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationForm_buyer">;
  readonly " $fragmentType": "CheckoutShippingForm_buyer";
};
export type CheckoutShippingForm_buyer$key = {
  readonly " $data"?: CheckoutShippingForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutShippingForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutShippingForm_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRegistrationForm_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5475c87f69c520460c2d772b383705a6";

export default node;
